module.exports = __webpack_public_path__ + "logo-muni-azul.png?c376f73e106e0a94ccb09c2488ca36c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-muni-azul.png
// module id = 677
// module chunks = 0 2 7 8 9 10